import { Icon, ListItemIcon, ListItemText, MenuItem } from '@/ui';

import RescheduleMenuItem from './Reschedule';

import type { Session } from '@/types';
import type { FC } from 'react';

import { canCancelSession } from '@/features/appointments/sessionCapabilities';

interface NextMenuItemsProps {
  enforceMemberRescheduleMinimumNotice?: boolean;
  enforceMemberRescheduleStartBoundary?: boolean;
  handleOnClose: (e: Event | React.SyntheticEvent) => void;
  onCancel?: (val: Session) => void;
  onReschedule?: (val: Session) => void;
  session: Session;
}

const NextMenuItems: FC<NextMenuItemsProps> = ({
  enforceMemberRescheduleMinimumNotice,
  enforceMemberRescheduleStartBoundary,
  session,
  handleOnClose,
  onReschedule = undefined,
  onCancel = undefined,
}) => {
  // Capability rules live in `sessionCapabilities` so `Menu/Upcoming` shares
  // the exact same predicate for hiding an action the API would reject.
  const showCancel = canCancelSession(session);
  return (
    <>
      <RescheduleMenuItem
        enforceMemberRescheduleMinimumNotice={
          enforceMemberRescheduleMinimumNotice
        }
        enforceMemberRescheduleStartBoundary={
          enforceMemberRescheduleStartBoundary
        }
        handleOnClose={handleOnClose}
        session={session}
        onReschedule={onReschedule}
      />
      {onCancel && showCancel ? (
        <MenuItem
          onClick={(e) => {
            handleOnClose(e);
            e.stopPropagation();
            onCancel(session);
          }}
        >
          <ListItemIcon>
            <Icon>trash</Icon>
          </ListItemIcon>
          <ListItemText>Cancel</ListItemText>
        </MenuItem>
      ) : null}
    </>
  );
};

export default NextMenuItems;
